/**
 * Breakpoints for responsive design.
 * All values are the **minimum** value.
 * Taken and extended from the Bootstrap breakpoints.
 */
export const breakpointXL = 1600; // Extreme large displays, nearing Full HD and more.
export const breakpointL = 1200; // Normal laptop screens, no normal phone portraits.
export const breakpointM = 992; // Landscape mode of phone, small tablet or big phone.
export const breakpointS = 768; // Small phones.
